import React from "react";
import Box from "components/common/Box";
import Card from "components/common/Card";
import CardContent from "components/common/CardContent";
import Stack from "components/common/Stack";
import Text from "components/common/Text";
import Divider from "components/common/Divider";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import { CardActions, CircularProgress } from "@mui/material";
import { makeStyles } from "@mui/styles";

const DashboardPopularTimes = (props) => {
  const classes = useStyles();
  return (
    <>
      <Card sx={{ minHeight: "380px" }}>
        {props.isLoadingpopulartimesdata ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              marginTop: "200px",
              height: "20vh",
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <Card sx={{ minHeight: "380px" }}>
            <CardContent>
              <Stack
                height="100%"
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
              >
                <Text className={classes.graphheading}>POPULAR TIMES</Text>
                <Box>
                  <Stack direction="row" spacing={2}>
                    <Text className={classes.dateheading}>
                      {props?.popular?.result?.since}-
                      {props?.popular?.result?.to}
                    </Text>
                  </Stack>
                </Box>
              </Stack>

              <Divider
                sx={{ marginTop: "15px", marginBottom: "15px" }}
                variant="middle"
              />
              <Box>
                <HighchartsReact
                  highcharts={Highcharts}
                  options={props.options}
                />
              </Box>
            </CardContent>
            <CardActions>
              <Stack
                className={classes.best_time}
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
                marginBottom="15px"
              >
                <Box
                  sx={{
                    color: "#707070",
                    background:
                      "rgba(25, 30, 170, 0.1) 0% 0% no-repeat padding-box",
                    borderRadius: "4px",
                    padding: "6px 20px",
                    marginLeft: "24px",
                  }}
                >
                  <Text
                    variant="span"
                    component="div"
                    gutterBottom
                    sx={{
                      letterSpacing: "0.28px",
                      color: "#4C72B7",
                      opacity: "1",
                      textAlign: "center",
                      fontSize: "11px",
                      font: "Nunito Sans, SemiBold",
                    }}
                  >
                    Busy time - {props?.popular?.result?.best_time?.time}
                  </Text>
                </Box>

                <Box
                  sx={{
                    color: "#707070",
                    background:
                      "rgba(25, 30, 170, 0.1) 0% 0% no-repeat padding-box",
                    borderRadius: "4px",
                    padding: "6px 20px",
                  }}
                >
                  <Text
                    variant="span"
                    component="div"
                    gutterBottom
                    sx={{
                      letterSpacing: "0.28px",
                      color: "#4C72B7",
                      opacity: "1",
                      textAlign: "center",
                      fontSize: "11px",
                      font: "Nunito Sans, SemiBold",
                    }}
                  >
                    Best time - {props?.popular?.result?.worst_time?.time}
                  </Text>
                </Box>
              </Stack>
            </CardActions>
          </Card>
        )}
      </Card>
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  HighchartsFirst: {
    "& .highcharts-container": {
      width: "100% !important",
    },
    "& .highcharts-root": {
      width: "100% !important",
    },
  },

  graphheading: {
    fontSize: "15px",
    color: "#545454",
    letterSpacing: "0.09px",
    textTransform: "uppercase",
    font: "Nunito Sans",
    fontWeight: "bold",
  },

  best_time: {
    ["@media (max-width:768px)"]: {
      marginLeft: "8px",
    },
  },

  dateheading: {
    fontSize: "14px",
    color: "#B4B4BE",
    font: "Nunito Sans",
  },
}));

export default DashboardPopularTimes;
